import * as React from 'react'
import {Box, LinearProgress, Typography} from "@mui/material";
import {formatPercentage} from "@ui-seeker/utils";


const styles = {
	height: 10,
	borderRadius: 5,
	backgroundColor: "divider",

	".MuiLinearProgress-bar": {
		backgroundColor: "#fe813b",
	}
}

export default function stockColumn() {
	return {
		name: 'numStock', label: 'Stock',
		options: {
			headerAlign: 'left',
			customBodyRowRenderLite: value => <Box>
				<LinearProgress variant="determinate" value={value} sx={styles} />
				<Typography color="text.secondary" sx={{ textAlign: 'right', fontStyle: 'italic', fontSize: 10 }}>
					{formatPercentage(value)}
				</Typography>
			</Box>
		}
	}
}